itsoftApp.createModule("socials", function () {
    const module = this;

    const Socials = function() {
        this.path = "https://yastatic.net/share2/share.js";
        this.blocks = document.querySelectorAll('.js-socials.js-invisible');
        this.init();
    };
    Socials.prototype.load = function() {
        itsoftApp.loadScript(this.path);
    };
    Socials.prototype.init = function() {
        this.load();
        this.blocks.forEach((el) => el.classList.remove('js-invisible'));
    }
    module.callback = Socials;
});